<template>
  <div class="not-found-container">
    <h1>404</h1>
    <p>عذراً، الصفحة غير موجودة</p>
    <router-link to="/" class="home-link">العودة إلى الصفحة الرئيسية</router-link>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head';
useHead({
  title: '404 | الصفحة غير موجودة | Trends Today',
  meta: [
    { name: 'description', content: 'عذراً، الصفحة التي تبحث عنها غير موجودة على Trends Today من MTN السودان.' },
    { property: 'og:title', content: '404 | الصفحة غير موجودة | Trends Today' },
    { property: 'og:description', content: 'عذراً، الصفحة التي تبحث عنها غير موجودة على Trends Today من MTN السودان.' },
    { property: 'og:image', content: 'https://trendtody.com/assets/img/trends.png' },
    { property: 'og:type', content: 'website' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: '404 | الصفحة غير موجودة | Trends Today' },
    { name: 'twitter:description', content: 'عذراً، الصفحة التي تبحث عنها غير موجودة على Trends Today من MTN السودان.' },
    { name: 'twitter:image', content: 'https://trendtody.com/assets/img/trends.png' },
    { name: 'robots', content: 'noindex, follow' }
  ]
});
</script>

<style scoped>
.not-found-container {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
h1 {
  font-size: 6rem;
  color: #f9d923;
  margin-bottom: 1rem;
}
p {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 2rem;
}
.home-link {
  display: inline-block;
  padding: 0.75rem 2rem;
  background: #f9d923;
  color: #222;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  transition: background 0.2s;
}
.home-link:hover {
  background: #ffd700;
}
</style>